import { BackgroundImage, ColumnElement } from '@typedream/components';
import {
  ColumnElement as ColumnElementType, DreamValue,
} from '@typedream/core';
import { PlateRenderElementProps } from '@udecode/plate-core';
import { pick } from 'lodash';
import Image from 'next/legacy/image';

export function ColumnElementEditor(
  props: PlateRenderElementProps<DreamValue, ColumnElementType>,
) {
  const { element } = props;

  return (
    <ColumnElement
      {...pick(props, ['element', 'className', 'attributes', 'children'])}
      backgroundImageElement={
        element.backgroundImage ? (
          <BackgroundImage
            src={element.backgroundImage}
            darken={element.backgroundDarken}
            optimizedImageComponent={Image}
          />
        ) : undefined
      }
    />
  );
}
